import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Printer, ArrowLeft } from "lucide-react";
import styles from "./styles/OrderPrint.module.css";

const OrderPrint = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { orderId, customerName, totalAmount } = state || {};

  // اطلاعات نمونه برای نمایش
  const orderDetails = {
    orderDate: new Date().toLocaleString("fa-IR"),
    expertNumber: "09385912556",
    paymentMethod: "پرداخت در محل",
    status: "تکمیل شده",
  };

  const handlePrint = () => {
    window.print();
  };

  const handleBack = () => {
    navigate("/");
  };

  if (!state) {
    return (
      <div className={styles.container}>
        <p>اطلاعات سفارش یافت نشد</p>
        <button onClick={handleBack} className={styles.backButton}>
          <ArrowLeft size={16} /> بازگشت به صفحه اصلی
        </button>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.printArea}>
        <div className={styles.header}>
          <h1> پیش فاکتور سفارش</h1>
          <div className={styles.logo}>فروشگاه باتری100</div>
        </div>

        <div className={styles.orderInfo}>
          <div className={styles.infoRow}>
            <span>شماره فاکتور:</span>
            <strong>{orderId}</strong>
          </div>
          <div className={styles.infoRow}>
            <span>تاریخ سفارش:</span>
            <strong>{orderDetails.orderDate}</strong>
          </div>
          <div className={styles.infoRow}>
            <span>نام مشتری:</span>
            <strong>{customerName}</strong>
          </div>
          <div className={styles.infoRow}>
            <span>شماره تماس کارشناس :</span>
            <strong>{orderDetails.expertNumber}</strong>
          </div>
          <div className={styles.infoRow}>
            <span>مبلغ قابل پرداخت:(پرداخت در زمان تحویل)</span>
            <strong>{totalAmount.toLocaleString()} تومان</strong>
          </div>
          <div className={styles.infoRow}>
            <span>وضعیت سفارش:</span>
            <strong className={styles.status}>{orderDetails.status}</strong>
          </div>
        </div>

        <div className={styles.footer}>
          <p>با تشکر از خرید شما</p>
          <p>برای پیگیری های بعدی شماره فاکتور را نزد خود نگه دارید</p>
        </div>
      </div>

      <div className={styles.actions}>
        <button onClick={handlePrint} className={styles.printButton}>
          <Printer size={18} /> چاپ فاکتور
        </button>
        <button onClick={handleBack} className={styles.backButton}>
          <ArrowLeft size={16} /> بازگشت به صفحه اصلی
        </button>
      </div>
    </div>
  );
};

export default OrderPrint;
